export default "__VITE_ASSET__DdB66va1__"